export const SUPPORTED_DOCUMENT_FILE_EXTENSIONS = [
  '.ppt',
  '.pptx',
  '.doc',
  '.docx',
  '.txt',
  '.xls',
  '.xlsx',
  '.pdf',
  '.jpg',
  '.jpeg',
  '.png',
  '.bmp',
  '.gif',
  '.csv',
]
